<template>
  <eagle-form
    :form-key="formKey"
  ></eagle-form>
</template>

<script lang="babel" type="text/babel">
import formMixin from '@/components/form/mixins/formMixin'
import formConfig from './siteAdminFormConfig'
export default {
  mixins: [formMixin],
  data: () => ({
    formKey: 'site-admin-form',
    meta: {},
  }),
  methods: {
    async beforeFormInit() {
      await Promise.all([
        this.loadSiteAdminRoles(),
      ])
    },
    async loadSiteAdminRoles() {
      const result = await this.$api.collection.siteAdminApi.roles()
      this.meta.roles = result.roles
    },
    validateBeforeSave() {
      // TODO
    },
    async readApi(target) {
      return await this.$api.collection.siteAdminApi.read(target)
    },
    async createApi(formData) {
      return await this.$api.collection.siteAdminApi.create(formData)
    },
    async updateApi(target, formData) {
      return await this.$api.collection.siteAdminApi.update(target, formData)
    },
    async deleteApi(target) {
      return await this.$api.collection.siteAdminApi.delete(target)
    },
    getFormConfig() {
      return formConfig
    },
  },
}
</script>

<style lang="sass" type="text/sass" scoped></style>
